import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useSignalR } from '../contexts/SignalRContext';
import { selectApiUrls } from '../redux/slices/apiUrlSlice';
import { RealtimeProvider } from './RealtimeProvider';
import { deployedEnvironment } from './deployedTransport';

// Share the working /api/negotiate connection; no second connection or session
// Inventing a group-join method would not work: the deployed API has none yet.
export function PortalRealtimeProvider(props) {
  const { subscribe, subscribeDomain, status, endpoint } = useSignalR();
  const urls = useSelector(selectApiUrls);
  const transport = useMemo(() => {
    try {
      const apiBase = new URL('.', urls.generalProjectInfoEnhanced).href;
      const environment = deployedEnvironment(apiBase, endpoint);
      return { subscribe, apiBase, environment, subscribeDomain: environment ? subscribeDomain : undefined };
    }
    catch { return undefined; }
  }, [subscribe, subscribeDomain, endpoint, urls.generalProjectInfoEnhanced]);
  return <RealtimeProvider {...props} pilotTransport={transport} pilotStatus={status} />;
}
